// Web implementation for exiting full screen mode.
export const exitFullScreen = ()=>{
    window.parent.postMessage({type:"psi-exit-full-screen"},"*")
}